module.exports = __webpack_public_path__ + "assets/img/personalize-banner.37169d98.jpg";